<template>
  <div v-show="value" :class="dialogClasses" :ref="`dialog_${_uid}`">
    <slot />
  </div>
</template>

<script>
/**
 * Define the dialog component
 */
export default {
  // set component name
  name: "r-dialog",

  // external props
  props: {
    // if the dialog is open
    value: {
      type: Boolean,
      default: false
    },

    // width of the dialog
    width: {
      type: String,
      default: "500px"
    },

    // height of the dialog
    height: {
      type: String,
      default: "400px"
    },

    // external classes
    classes: {
      type: Object,
      default: () => ({})
    }
  },

  /**
   * Hook to life cycle and
   * append listeners.
   */
  mounted() {
    document.addEventListener("mousedown", this.closeByClick)
    document.addEventListener("keydown", this.closeByEsc)
  },

  /**
   * Hook into lifecycle and remove
   * listeneres.
   */
  beforeDestroy() {
    document.removeEventListener("mousedown", this.closeByClick)
    document.removeEventListener("keydown", this.closeByEsc)
  },

  // component's function
  methods: {
    /**
     * Emit the close event.
     */
    close() {
      this.$emit("on-close")
      this.$emit("input", false)
    },

    /**
     * Detect ESC keypress and close dialog.
     */
    closeByEsc(e) {
      if (e.key === "Escape") {
        this.close()
      }
    },

    /**
     * Detect outside click and close dialog.
     */
    closeByClick(e) {
      // get element
      const elem = this.$refs[`dialog_${this._uid}`]

      // find click outside
      if (!e.target.closest(".r-dialog")) {
        if (elem) {
          this.close()
        }
      }
    }
  },

  // computed props
  computed: {
    /**
     * Returns the calculated classes
     */
    dialogClasses() {
      return {
        fixed: true,
        "r-dialog": true,
        "duration-100": true,
        "transition-all": true,

        "w-screen": true,
        "h-auto": true,
        "md:w-1/3": true,
        "md:min-w-0": true,
        "md:h-auto": true,
        ...this.classes
      }
    },

    /**
     * Render custom styles
     */
    styles() {
      return {
        width: this.width,
        height: this.height
      }
    }
  }
}
</script>

<style lang="scss">
.r-dialog {
  // position
  top: 52%;
  left: 50%;
  z-index: 10;
  transform: translate(-50%, -52%);
}
</style>
